import { RouterConfig } from '@angular/router';
import {NewYearRolloverComponent} from './new-year-rollover.component';
import {NewYearStepsComponent} from './new-year-rollover-steps/new-year-rollover-steps.component';
import {NewYearReportsComponent} from './new-year-rollover-reports/new-year-rollover-reports.component';

export const NewYearRolloverRoutes: RouterConfig = [
    {path:'new-year-rollover', component:NewYearRolloverComponent},
    {path: 'new-year-rollover-steps', component: NewYearStepsComponent},
    {path: 'new-year-rollover-reports', component: NewYearReportsComponent},
];


/** WEBPACK FOOTER **
 ** ./app/system-management/new-year-rollover/new-year-rollover.routes.ts
 **/